<ng-container *ngIf="customer$ | async as customer">
  <h2 mat-dialog-title>
    <ng-container *ngIf="step === phoneNumberEditStep.PHONE_NUMBER">
      <ng-container *ngIf="customer.phoneNumber">
        <ng-container *ngIf="customer.verificationStatus === 'VERIFIED'">Zmiana numeru telefonu</ng-container>
        <ng-container *ngIf="customer.verificationStatus !== 'VERIFIED'">Weryfikacja numeru telefonu</ng-container>
      </ng-container>
      <ng-container *ngIf="!customer.phoneNumber"> Wprowadzanie numeru telefonu </ng-container>
    </ng-container>
    <ng-container
      *ngIf="
        step === phoneNumberEditStep.VERIFICATION_CODE || step === phoneNumberEditStep.PHONE_NUMBER_USED_WITH_COUPON
      "
    >
      Weryfikacja numeru telefonu
    </ng-container>
  </h2>

  <div *ngIf="step === phoneNumberEditStep.PHONE_NUMBER">
    <form id="phoneNumberEdit" [formGroup]="phoneNumberEditForm">
      <mat-form-field appearance="outline">
        <mat-label>Numer telefonu</mat-label>
        <input
          formControlName="phoneNumber"
          mask="000 000 000"
          matInput
          name="phoneNumber"
          prefix="+48 "
          inputmode="numeric"
          type="text"
        />

        <mat-error *ngIf="!phoneNumberEditForm.phoneNumber.untouched && !!phoneNumberEditForm.phoneNumber.errors">
          {{ getPhoneNumberErrorMessage(phoneNumberEditForm.phoneNumber.errors) }}
        </mat-error>
      </mat-form-field>
    </form>
  </div>

  <div *ngIf="step === phoneNumberEditStep.PHONE_NUMBER_USED_WITH_COUPON">
    <p>Numer który weryfikujesz, był przypisany do konta, na którym został wykorzystany kupon za rejestrację.</p>
    <p>Przechodząc dalej, decydujesz się na bezpowrotne zablokowanie Twojego kuponu za rejestrację.</p>
  </div>

  <div *ngIf="step === phoneNumberEditStep.VERIFICATION_CODE">
    <p>
      Kod weryfikacyjny został wysłany na numer
      <span class="nowrap">+48 {{ phoneNumberEditForm.phoneNumber.value | mask: '000 000 000' }}</span
      ><span>.</span>
      Wpisz kod w polu poniżej.
    </p>

    <form id="phoneNumberVerificationCode" [formGroup]="phoneNumberVerificationCodeForm">
      <mat-form-field appearance="outline">
        <mat-label>Kod weryfikacyjny</mat-label>
        <!--Workaround for https://github.com/angular/angular/issues/14057-->
        <input
          [formControl]="phoneNumberVerificationCodeForm.verificationCode"
          mask="000000"
          matInput
          name="verificationCode"
          type="text"
          inputmode="numeric"
        />

        <mat-error
          *ngIf="
            !phoneNumberVerificationCodeForm.verificationCode.untouched &&
            phoneNumberVerificationCodeForm.verificationCode.dirty &&
            !!phoneNumberVerificationCodeForm.verificationCode.errors
          "
        >
          {{
            !!phoneNumberVerificationCodeForm.verificationCode.errors?.invalidCode
              ? 'Kod weryfikacyjny jest nieprawidłowy lub utracił ważność'
              : 'Podaj poprawny kod veryfikacyjny'
          }}
        </mat-error>
      </mat-form-field>
    </form>

    <p>
      Nie możesz znaleźć kodu weryfikacyjnego?<br />
      <ng-container *ngIf="timer$ | async as counterValue">
        Możesz wysłać kod ponownie za {{ counterValue }}s.
      </ng-container>
      <a *ngIf="timerValue === 0" (click)="sendVerificationSMS()" class="resend-btn">Wyślij ponownie.</a>
    </p>
  </div>

  <mat-dialog-actions align="start">
    <button
      *ngIf="step === phoneNumberEditStep.VERIFICATION_CODE"
      color="primary"
      mat-raised-button
      type="submit"
      form="phoneNumberVerificationCode"
      (click)="save()"
      [disabled]="
        phoneNumberVerificationCodeForm.invalid ||
        (loadingService.watch({
          action: loadingAction.PHONE_VERIFICATION,
          namespace: 'phone_verification',
          id: customer.customerId
        }) | async) ||
        phoneVerified
      "
    >
      Zapisz
    </button>
    <button
      *ngIf="step === phoneNumberEditStep.PHONE_NUMBER"
      color="primary"
      mat-raised-button
      type="submit"
      form="phoneNumberEdit"
      (click)="saveNumber()"
      [disabled]="phoneNumberEditForm.phoneNumber.invalid"
    >
      Dalej
    </button>
    <button
      *ngIf="step === phoneNumberEditStep.PHONE_NUMBER_USED_WITH_COUPON"
      color="primary"
      mat-raised-button
      autofocus
      (click)="acceptCouponLost()"
    >
      Dalej
    </button>
    <button mat-button (click)="close(false)">Zamknij</button>
  </mat-dialog-actions>
</ng-container>
